import {AbstractControl} from '@angular/forms';

export function emailNumberValidator(control: AbstractControl) {
  const regExp = /^[0-9]*$/;
  const valid = regExp.test(control.value);
  return valid ? null : {invalidFormat: !valid};
}
